export const EXCLUDED_TAGS = []
export const STYLE_ID = 'i18n-key-overlay-style'
export const THROTTLE_MS = 500
export const SENT = {
  ORANGE_PREFIX: '\u2063I18NKEY|',
  MISS_PREFIX: '\u2063I18NMISS|',
  SEP: '|',
  CLOSE: '\u2063',
}
// U+2063 is the invisible separator character - our "sentinel" character

// Unified sentinel parsing regex (captures type, key, value)
export const SENTINEL_REGEX = /\u2063I18N(KEY|MISS)\|([^|]+)\|([\s\S]*)\u2063/
